module.exports = __webpack_public_path__ + "img/aa9ece8bbc86fa10460896e1fd66ae97.svg";